import { gql } from '@apollo/client';

export * from './updateCompany.mutation.generated';

export const UPDATE_COMPANY_DETAILS = gql`
  mutation updateCompany($companyInput: CompanyInput!) {
    updateCompany(input: { companyInput: $companyInput }) {
      success
      errors
      company {
        city
        companyName
        companyRegistration
        companyWebsite
        country
        id
        postalCode
        region
        street
        invitationStatus
        streetNumber
      }
    }
  }
`;
